/* eslint-disable react-hooks/exhaustive-deps */
import React, { Suspense, useEffect } from "react";
import "./App.css";
import "./ChatWidget.css";
import "./dashboardLayout.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { AllCommunityModule } from "ag-grid-community";
import { AgGridProvider } from "ag-grid-react";
import {
  // BrowserRouter,
  Switch,
  Route,
  useHistory,
  Redirect,
} from "react-router-dom";
import { useSelector } from "react-redux";
import AltertModal from "./component/AlertModal/AltertModal";
import { AuthProvider } from "./context/useAuth.js";
import { AdminRoutes } from "./component/AllRoutes/index.js";
import RequireAuth from "./component/RequireAuth/RequireAuth.jsx";
import Layout from "./Layout/Layout.js";
import { getFirstAllowedUrl, isCommissionAuthorizedUser, isModuleLanding, menuForPath } from "./Utils/roleNavigation";
import { SubbtnProvider } from "./context/subBtn.js";
import { RolesProvider } from "./context/roles.js";
// import { getallRoles } from "./Redux/actions/getroles.js";
import AppLoader from "./component/AppLoader/AppLoader.js";
import AccessDenied from "./Common/AccessDenied.jsx";
import { useSubscription } from "./context/SubscriptionContext.js";
import { SignalRProvider } from "./context/SignalRContext.js";
import { storage, sessionStore } from "./Utils/storageService";

const modules = [AllCommunityModule];

// Rendered when no permitted route matched the url. A forbidden module dashboard
// (the hardcoded landing of login / project selection / top nav) is redirected to the
// first screen of that module the user can open; anything else — a typed or
// bookmarked screen they lack, or a module with nothing permitted — is Access Denied.
const RoleFallback = ({ path, menu, userRoles, userEmail }) => {
  // Roles not loaded yet: AccessDenied renders nothing until they are, and deciding
  // a redirect now would be based on an empty role list.
  if (!userRoles) {
    return <AccessDenied />;
  }
  if (isModuleLanding(path)) {
    const target = getFirstAllowedUrl(menu, userRoles, {
      hasProject: !!storage.getProjectId(),
    }, userEmail);
    if (target && target !== path) {
      return <Redirect to={target} />;
    }
  }
  return <AccessDenied />;
};

function App() {
  const history = useHistory();
  const rolesdata = useSelector((state) => state.GetAllRole);
  const { setSubscriptionError } = useSubscription();
  // const dispatch = useDispatch();
  useEffect(() => {
    if (rolesdata) {
      setSubscriptionError(rolesdata);
    }
  }, [rolesdata]);
  useEffect(() => {
    if (!storage.getToken()) {
      history.push("/");
    }
    sessionStore.setIsPaid("false");
  }, [history]);
  // useEffect(() => {
  //   if (localStorage.getItem("token")) {
  //     dispatch(getallRoles());
  //   }
  // }, [dispatch]);

  return (
    // <BrowserRouter>
    <SubbtnProvider>
      <RolesProvider>
        <SignalRProvider>
          <AgGridProvider modules={modules}>
            <Switch>
              <AuthProvider>
                {AdminRoutes.filter((route) =>
                  ["/", "/reset", "/forgot", "/verify", "/projectSelection", "/public/*"].includes(
                    route.path,
                  ),
                ).map((route, idx) => (
                  <Suspense fallback={<AppLoader />} key={route.path || idx}>
                    <Route key={route.path || idx} exact path={route.path}>
                      {route.Component ? (
                        <route.Component {...(route.props || {})} />
                      ) : (
                        route.component
                      )}
                    </Route>
                  </Suspense>
                ))}

                <Route
                  path="/"
                  render={({ location }) => {
                    const path = location.pathname;
                    const userEmail = rolesdata?.data?.UserName || "";
                    const canAccessCommissions = isCommissionAuthorizedUser(userEmail);

                    const isPublic =
                      ["/", "/reset", "/forgot", "/verify", "/projectSelection"].includes(path) ||
                      path?.startsWith("/public/");
                    // if (path === "/" && localStorage.getItem("token")) {
                    //   return <Redirect to="/inventory/dashboard" />;
                    // }

                    // Check if user has token and is on root
                    if (path === "/" && storage.getToken()) {
                      const userRoles = rolesdata?.data?.UserRoles || [];
                      if (userRoles.includes("Accounts")) {
                        return <Redirect to="/projectSelection" />;
                      }
                      if (
                        userRoles.includes("Accounts_Contract") ||
                        userRoles.includes("Contract")
                      ) {
                        return (
                          <Redirect
                            to={{ pathname: "/projectSelection", state: { module: "Contract" } }}
                          />
                        );
                      }
                      if (userRoles.includes("Property Management")) {
                        return (
                          <Redirect
                            to={{ pathname: "/projectSelection", state: { module: "Property" } }}
                          />
                        );
                      }
                      if (
                        userRoles.includes("ERP-Settings") &&
                        !userRoles.includes("Inventory") &&
                        !userRoles.includes("Human Resource")
                      ) {
                        return <Redirect to="/settings" />;
                      }

                      // Find the dashboard route in AdminRoutes that the user has access to
                      const dashboardRoute = AdminRoutes.find(
                        (route) =>
                          route.path === "/inventory/dashboard" &&
                          route.rolename &&
                          userRoles.includes(route.rolename),
                      );
                      if (dashboardRoute) {
                        return <Redirect to="/inventory/dashboard" />;
                      } else {
                        // Find first accessible route for the user
                        const firstAllowedRoute = AdminRoutes.find(
                          (route) =>
                            route.path && route.rolename && userRoles.includes(route.rolename),
                        );
                        if (firstAllowedRoute) {
                          return <Redirect to={firstAllowedRoute.path} />;
                        } else {
                          return <AccessDenied />;
                        }
                      }
                    }

                    if (isPublic) {
                      return null;
                    }

                    const arr = menuForPath(path, userEmail);

                    const publicRoutes = ["/", "/reset", "/forgot", "/verify", "/projectSelection"];

                    const protectedRoutes = AdminRoutes.filter(
                      (route) =>
                        !publicRoutes.includes(route.path) &&
                        // /account/analytics/* routes now gated by role again (was TEMP'd open):
                        // route.path?.startsWith("/account/analytics/") ||
                        (route.path?.startsWith("/commission")
                          ? canAccessCommissions
                          :
                          (route.rolename && rolesdata?.data?.UserRoles?.includes(route.rolename))),
                    );

                    return (
                      <RequireAuth>
                        <Layout arr={arr}>
                          <Suspense fallback={<AppLoader />}>
                            <Switch>
                              {protectedRoutes?.map((route, idx) => (
                                <Route key={route.path || idx} exact path={route?.path}>
                                  {route.Component ? (
                                    <route.Component {...(route.props || {})} />
                                  ) : (
                                    route?.component
                                  )}
                                </Route>
                              ))}

                              <Route path="*">
                                <RoleFallback
                                  path={path}
                                  menu={arr}
                                  userRoles={rolesdata?.data?.UserRoles}
                                    userEmail={userEmail}
                                />
                              </Route>
                            </Switch>
                          </Suspense>
                        </Layout>
                      </RequireAuth>
                    );
                  }}
                />
              </AuthProvider>
              <AltertModal />
            </Switch>
          </AgGridProvider>
        </SignalRProvider>
      </RolesProvider>
    </SubbtnProvider>
    // </BrowserRouter>
  );
}

export default App;
